import { Typography } from '@mui/material';

export function CalculatorDisclaimerTitle() {
  return <Typography variant="textBold">Important information</Typography>;
}
